import { Dispatch } from 'redux';
import Cookies from 'universal-cookie';
import { authService } from '../../services/auth.service';
import {
  CHANGE_CREDENTIALS_ERROR,
  CHANGE_CREDENTIALS_SUCCESS,
  CHANGE_USER_PASSWORD_ERROR,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGING_CREDENTIALS,
  CHANGING_USER_PASSWORD,
  CONFIRMING_RESET_PASSWORD,
  CONFIRM_RESET_PASSWORD_ERROR,
  CONFIRM_RESET_PASSWORD_SUCCESS,
  ChangeCredentialsActionTypes,
  ChangeUserPasswordActionTypes,
  ConfirmResetPasswordActionTypes,
  GETTING_ACCOUNT,
  GET_ACCOUNT_ERROR,
  GET_ACCOUNT_SUCCESS,
  GetAccountActionTypes,
  GetUnconfirmedUsersActionTypes,
  LOGGING_IN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  CLEAR_AUTH_ERROR,
  LOGOUT,
  LoginActionTypes,
  LogoutActionTypes,
  REGISTERING_BUSINESS,
  REGISTERING_USER,
  REGISTER_BUSINESS_ERROR,
  REGISTER_BUSINESS_SUCCESS,
  REGISTER_USER_ERROR,
  REGISTER_USER_SUCCESS,
  RESENDING_CONFIRMATION,
  RESEND_CONFIRMATION_FAILED,
  RESEND_CONFIRMATION_SUCCESS,
  RESETING_PASSWORD,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
  RegisterBusinessActionTypes,
  RegisterUserActionTypes,
  ResendConfirmationTypes,
  ResetPasswordActionTypes,
  UPDATE_ACCOUNT_ERROR,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATING_ACCOUNT,
  UpdateAccountActionTypes,
  VALIDATE_REGISTER_ERROR,
  VALIDATE_REGISTER_SUCCESS,
  VALIDATING_REGISTER,
  VERIFYING_USER,
  VERIFY_USER_ERROR,
  VERIFY_USER_SUCCESS,
  ValidateRegisterActionTypes,
  VerifyUserActionTypes,
} from '../config/ActionTypes';
import {
  Account,
  Business,
  ChangeCredentialsRequest,
  ChangeUserPasswordRequest,
  ConfirmEmailRequest,
  ConfirmResetPasswordRequest,
  ConfirmResetPasswordSuccessResponse,
  ResetPasswordRequest,
  UnconfirmedUsersResponse,
  User,
  UserCredentials,
  UserRequest,
} from '../config/types';

//#region Login

const normalizeError = (error: any): string => {
  if (!error) return 'Ocurrió un error';
  // If base.service attached an originalMessage (raw backend message that may include JSON with QrCode)
  // prefer that so we can parse and render the QR. If not present, fall back to userMessage or Error.message.
  if (typeof error === 'string') return error;
  if (error.originalMessage && typeof error.originalMessage === 'string') return error.originalMessage;
  if (error.userMessage && typeof error.userMessage === 'string') return error.userMessage;
  if (error.message && typeof error.message === 'string') return error.message;
  try {
    return JSON.stringify(error);
  } catch (ex) {
    return String(error);
  }
};

export const login = (user: UserCredentials) => (dispatch: Dispatch<LoginActionTypes>) => {
  dispatch(loggingIn());

  return authService.login({ user }).then(
    (response) => {
      const cookies = new Cookies();
      cookies.set('token', response!.token, { path: '/' });
       console.log("response");
 console.log(response);
      dispatch(loginSuccess(response!.user));
    },
    (error) => {
      console.log('login error raw:', error);
      const normalized = normalizeError(error);
      const cookies = new Cookies();

      // Extract errorCode from error object
      let errorCode: number | undefined;
      let user: any = undefined;
      let token: string | undefined;
      try {
        // First try direct properties (this is where the data actually is)
        if (error && error.errorCode !== undefined) {
          errorCode = error.errorCode;
          console.log('Found errorCode directly on error:', errorCode);
          console.log('error.user exists?', !!error.user);
          console.log('error.token exists?', !!error.token);
          console.log('Full error object keys:', Object.keys(error));
          
          if (errorCode === 300) {
            console.log('Error 300 detected, extracting from direct properties');
            const parsedBody = (error as any).parsedBody;
            const parsedUser = parsedBody?.user ?? parsedBody?.User;
            const parsedToken = parsedBody?.token ?? parsedBody?.Token;

            if (error.user || (error as any).User) {
              user = error.user ?? (error as any).User;
              console.log('User extracted from error 300:', user);
            } else if (parsedUser) {
              console.log('error.user is not available, trying parsedBody...');
              user = parsedUser;
              console.log('User extracted from error.parsedBody:', user);
            }

            if (error.token || (error as any).Token) {
              token = error.token ?? (error as any).Token;
              console.log('Token extracted from error 300:', token);
              // Save token to cookies for authentication
              cookies.set('token', token, { path: '/' });
              console.log('Token saved to cookies');
            } else if (parsedToken) {
              console.log('error.token is not available, trying parsedBody...');
              token = parsedToken;
              console.log('Token extracted from error.parsedBody:', token);
              // Save token to cookies for authentication
              cookies.set('token', token, { path: '/' });
              console.log('Token saved to cookies');
            }
          }
        } 
        // Fallback to parsedBody (legacy code)
        else if (error && (error as any).parsedBody && (error as any).parsedBody.errorCode) {
          errorCode = (error as any).parsedBody.errorCode;
          
          // If error 300, extract user and token from parsedBody
          if (errorCode === 300) {
            const pb = (error as any).parsedBody;
            const parsedUser = pb?.user ?? pb?.User;
            const parsedToken = pb?.token ?? pb?.Token;
            console.log('Error 300 detected, parsedBody:', pb);
            if (parsedUser) {
              user = parsedUser;
              console.log('User extracted from error 300 parsedBody:', user);
            }
            if (parsedToken) {
              token = parsedToken;
              console.log('Token extracted from error 300 parsedBody:', token);
              // Save token to cookies for authentication
              cookies.set('token', token, { path: '/' });
              console.log('Token saved to cookies');
            }
          }
        }
        // Legacy fallback
        else if (error && (error as any).errorCode) {
          errorCode = (error as any).errorCode;
        }
      } catch (ex) {
        console.log('Error extracting errorCode:', ex);
        // no errorCode available
      }

      // Try to extract challenge from error.parsedBody (preferred) or from normalized string
      let twoFactorChallenge: string | undefined;
      try {
        const pb = error && (error as any).parsedBody;
        if (pb && pb.twoFactorSetupResponse) {
          // save the nested object as a string so UI can parse/display it
          twoFactorChallenge = typeof pb.twoFactorSetupResponse === 'string' ? pb.twoFactorSetupResponse : JSON.stringify(pb.twoFactorSetupResponse);
        } else {
          // fallback: if normalized is a JSON string containing QrCode/ManualCode, keep the whole JSON string
          const parsed = JSON.parse(normalized);
          if (parsed && (parsed.QrCode || parsed.ManualCode)) {
            twoFactorChallenge = normalized;
          }
        }
      } catch (ex) {
        // not JSON or no parsedBody -> nothing to do
      }

      // Debug info to help troubleshooting when QR is not detected
      try {
        // log originalMessage & userMessage if present on error
        // eslint-disable-next-line no-console
        console.log('login error debug:', {
          errorRaw: error,
          errorKeys: Object.keys(error || {}),
          originalMessage: error && (error as any).originalMessage,
          userMessage: error && (error as any).userMessage,
          parsedBody: error && (error as any).parsedBody,
          parsedBodyKeys: error && (error as any).parsedBody ? Object.keys((error as any).parsedBody) : [],
          response: error && (error as any).response,
          responseData: error && (error as any).response && (error as any).response.data,
          normalized,
          errorCode,
          user,
          token,
          twoFactorChallenge,
        });
      } catch (l) {}

      console.log('About to dispatch loginError with:', { normalized, twoFactorChallenge, errorCode, user });
      dispatch(loginError(normalized, twoFactorChallenge, errorCode, user));
    },
  );
};

const loggingIn = (): LoginActionTypes => ({
  type: LOGGING_IN,
});

const loginSuccess = (account: User): LoginActionTypes => ({
  type: LOGIN_SUCCESS,
  account,
});

const loginError = (error: string, twoFactorChallenge?: string, errorCode?: number, user?: any): LoginActionTypes => ({
  type: LOGIN_ERROR,
  error,
  twoFactorChallenge,
  errorCode,
  user,
});

export const clearAuthError = (): LoginActionTypes => ({
  type: CLEAR_AUTH_ERROR,
});

//#endregion

//#region Logout

export const logout = (): LogoutActionTypes => ({
  type: LOGOUT,
});

//#endregion

//#region Reset password

export const resetPassword =
  ({ email }: ResetPasswordRequest) =>
  (dispatch: Dispatch<ResetPasswordActionTypes>) => {
    dispatch(resetingPassword());

    const resetPasswordRequest: ResetPasswordRequest = {
      email,
    };

    return authService.resetPassword(resetPasswordRequest).then(
      (response) => {
        dispatch(resetPasswordSuccess());
      },
      (error) => {
        dispatch(resetPasswordError(error));
      },
    );
  };

const resetingPassword = (): ResetPasswordActionTypes => ({
  type: RESETING_PASSWORD,
});

const resetPasswordSuccess = (): ResetPasswordActionTypes => ({
  type: RESET_PASSWORD_SUCCESS,
});

const resetPasswordError = (error: string): ResetPasswordActionTypes => ({
  type: RESET_PASSWORD_ERROR,
  error,
});

//#endregion

//#region Confirm reset password

export const confirmResetPassword =
  ({ id, token }: ConfirmResetPasswordRequest) =>
  (dispatch: Dispatch<ConfirmResetPasswordActionTypes>) => {
    dispatch(confirmingResetPassword());

    return authService.confirmResetPassword({ id, token }).then(
      (response) => {
        dispatch(confirmResetPasswordSuccess(response!));
      },
      (error) => {
        dispatch(confirmResetPasswordError(error));
      },
    );
  };

const confirmingResetPassword = (): ConfirmResetPasswordActionTypes => ({
  type: CONFIRMING_RESET_PASSWORD,
});

const confirmResetPasswordSuccess = (
  response: ConfirmResetPasswordSuccessResponse,
): ConfirmResetPasswordActionTypes => ({
  type: CONFIRM_RESET_PASSWORD_SUCCESS,
  response,
});

const confirmResetPasswordError = (error: string): ConfirmResetPasswordActionTypes => ({
  type: CONFIRM_RESET_PASSWORD_ERROR,
  error,
});

//#endregion

//#region Register user

export const registerUser = (user: UserRequest) => (dispatch: Dispatch<RegisterUserActionTypes>) => {
  dispatch(registeringUser());

  return authService.registerUser({ user }).then(
    (response) => {
      dispatch(registerUserSuccess(response!));
    },
    (error) => {
      dispatch(registerUserError(error));
    },
  );
};

const registeringUser = (): RegisterUserActionTypes => ({
  type: REGISTERING_USER,
});

const registerUserSuccess = (user: UserCredentials): RegisterUserActionTypes => ({
  type: REGISTER_USER_SUCCESS,
  user,
});

const registerUserError = (error: string): RegisterUserActionTypes => ({
  type: REGISTER_USER_ERROR,
  error,
});

//#endregion

//#region Validate register

export const validateRegister =
  ({ userId, token }: ConfirmEmailRequest) =>
  (dispatch: Dispatch<ValidateRegisterActionTypes>) => {
    dispatch(validatingRegister());

    return authService.validateRegister({ userId, token }).then(
      (response) => {
        if (response) {
          const cookies = new Cookies();
          cookies.set('token', response!.token, { path: '/' });

          dispatch(validateRegisterSuccess());
        } else {
          dispatch(validateRegisterError('Email ya existente.'));
        }
      },
      (error) => {
        dispatch(validateRegisterError(error));
      },
    );
  };

const validatingRegister = (): ValidateRegisterActionTypes => ({
  type: VALIDATING_REGISTER,
});

const validateRegisterSuccess = (): ValidateRegisterActionTypes => ({
  type: VALIDATE_REGISTER_SUCCESS,
});

const validateRegisterError = (error: string): ValidateRegisterActionTypes => ({
  type: VALIDATE_REGISTER_ERROR,
  error,
});

//#endregion

//#region Register business

export const registerBusiness = (business: Business) => (dispatch: Dispatch<RegisterBusinessActionTypes>) => {
  dispatch(registeringBusiness());

  return authService.registerBusiness(business).then(
    (response) => {
      dispatch(registerBusinessSuccess(response!));
    },
    (error) => {
      // Extract errorCode from error object
      let errorCode: number | undefined;
      try {
        if (error && (error as any).errorCode) {
          errorCode = (error as any).errorCode;
        } else if (error && (error as any).parsedBody && (error as any).parsedBody.errorCode) {
          errorCode = (error as any).parsedBody.errorCode;
        }
      } catch (ex) {
        // no errorCode available
      }
      
      dispatch(registerBusinessError(error, errorCode));
    },
  );
};

const registeringBusiness = (): RegisterBusinessActionTypes => ({
  type: REGISTERING_BUSINESS,
});

const registerBusinessSuccess = (business: Business): RegisterBusinessActionTypes => ({
  type: REGISTER_BUSINESS_SUCCESS,
  business,
});

const registerBusinessError = (error: string, errorCode?: number): RegisterBusinessActionTypes => ({
  type: REGISTER_BUSINESS_ERROR,
  error,
  errorCode,
});

//#endregion

//#region Get account

export const getAccount = () => (dispatch: Dispatch<GetAccountActionTypes>) => {
  dispatch(gettingAccount());

  return authService.getAccount().then(
    (response) => {
      dispatch(getAccountSuccess(response!));
    },
    (error) => {
      dispatch(getAccountError(error));
    },
  );
};

const gettingAccount = (): GetAccountActionTypes => ({
  type: GETTING_ACCOUNT,
});

const getAccountSuccess = (account: User): GetAccountActionTypes => ({
  type: GET_ACCOUNT_SUCCESS,
  account,
});

const getAccountError = (error: string): GetAccountActionTypes => ({
  type: GET_ACCOUNT_ERROR,
  error,
});

//#endregion

//#region Update account

export const updateAccount = (account: Account) => (dispatch: Dispatch<UpdateAccountActionTypes>) => {
  dispatch(updatingAccount());

  return authService.updateAccount(account).then(
    (response) => {
      dispatch(updateAccountSuccess(response!));
    },
    (error) => {
      dispatch(updateAccountError(error));
    },
  );
};

const updatingAccount = (): UpdateAccountActionTypes => ({
  type: UPDATING_ACCOUNT,
});

const updateAccountSuccess = (account: User): UpdateAccountActionTypes => ({
  type: UPDATE_ACCOUNT_SUCCESS,
  account,
});

const updateAccountError = (error: string): UpdateAccountActionTypes => ({
  type: UPDATE_ACCOUNT_ERROR,
  error,
});

//#endregion

//#region Change credentials

export const changeCredentials =
  (changeCredentialsRequest: ChangeCredentialsRequest) =>
  (dispatch: Dispatch<ChangeCredentialsActionTypes>) => {
    dispatch(changingCredentials());

    return authService.modifyCredentials(changeCredentialsRequest).then(
      (response) => {
        dispatch(changeCredentialsSuccess());
      },
      (error) => {
        dispatch(changeCredentialsError(error));
      },
    );
  };

const changingCredentials = (): ChangeCredentialsActionTypes => ({
  type: CHANGING_CREDENTIALS,
});

const changeCredentialsSuccess = (): ChangeCredentialsActionTypes => ({
  type: CHANGE_CREDENTIALS_SUCCESS,
});

const changeCredentialsError = (error: string): ChangeCredentialsActionTypes => ({
  type: CHANGE_CREDENTIALS_ERROR,
  error,
});

//#endregion

//#endregion

//#region Change credentials

export const changeUserPassword =
  (changeUserPasswordRequest: ChangeUserPasswordRequest) =>
  (dispatch: Dispatch<ChangeUserPasswordActionTypes>) => {
    dispatch(changingUserPassword());

    return authService.changeUserPassword(changeUserPasswordRequest).then(
      (response) => {
        dispatch(changeUserPasswordSuccess());
      },
      (error) => {
        dispatch(changeUserPasswordError(error));
      },
    );
  };

const changingUserPassword = (): ChangeUserPasswordActionTypes => ({
  type: CHANGING_USER_PASSWORD,
});

const changeUserPasswordSuccess = (): ChangeUserPasswordActionTypes => ({
  type: CHANGE_USER_PASSWORD_SUCCESS,
});

const changeUserPasswordError = (error: string): ChangeUserPasswordActionTypes => ({
  type: CHANGE_USER_PASSWORD_ERROR,
  error,
});

//#endregion

//#region Unconfirmed users

export const getUnconfirmedUsers = (searchTerm?: string) => {
  return (dispatch: Dispatch<GetUnconfirmedUsersActionTypes>) => {
    dispatch(gettingUnconfirmedUsers());

    return authService.getUnconfirmedUsers(searchTerm).then(
      (response) => {
        dispatch(getUnconfirmedUsersSuccess(response!));
      },
      (error) => {
        dispatch(getUnconfirmedUsersError(error));
      },
    );
  };
};

const gettingUnconfirmedUsers = (): GetUnconfirmedUsersActionTypes => ({
  type: 'GETTING_UNCONFIRMED_USERS',
});

const getUnconfirmedUsersSuccess = (users: UnconfirmedUsersResponse): GetUnconfirmedUsersActionTypes => ({
  type: 'GET_UNCONFIRMED_USERS_SUCCESS',
  users: users,
});

const getUnconfirmedUsersError = (error: string): GetUnconfirmedUsersActionTypes => ({
  type: 'GET_UNCONFIRMED_USERS_ERROR',
  error,
});

//#endregion

//#region Resend confirmation

export const resendConfirmation = (email: string) => {
  return (dispatch: Dispatch<ResendConfirmationTypes>) => {
    dispatch(resendingConfirmation());

    return authService.resendConfirmation(email).then(
      (response) => {
        dispatch(resendConfirmationSuccess(response!));
      },
      (error) => {
        dispatch(resendConfirmationError(error));
      },
    );
  };
};

export const resendingConfirmation = (): ResendConfirmationTypes => ({
  type: RESENDING_CONFIRMATION,
});

export const resendConfirmationSuccess = (confirmation: string): ResendConfirmationTypes => ({
  type: RESEND_CONFIRMATION_SUCCESS,
  confirmation,
});

export const resendConfirmationError = (error: string): ResendConfirmationTypes => ({
  type: RESEND_CONFIRMATION_FAILED,
  error,
});

//#endregion

//#region Verify User

export const verifyUser = (userId: string) => {
  return (dispatch: Dispatch<VerifyUserActionTypes>) => {
    dispatch(verifyingUser());

    return authService.verifyUser(userId).then(
      (response) => {
        dispatch(verifyUserSuccess(response!));
      },
      (error) => {
        dispatch(verifyUserError(error));
      },
    );
  };
};

export const verifyingUser = (): VerifyUserActionTypes => ({
  type: VERIFYING_USER,
});

export const verifyUserSuccess = (verification: string): VerifyUserActionTypes => ({
  type: VERIFY_USER_SUCCESS,
  verification,
});

export const verifyUserError = (error: string): VerifyUserActionTypes => ({
  type: VERIFY_USER_ERROR,
  error,
});

//#endregion
